import React, { useState, useEffect } from 'react';
import { Check, Clock } from 'lucide-react';
import './SurveyMilestone.css';

const SurveyMilestones = ({ hasReport }) => {
    const [milestones, setMilestones] = useState([
        {
            id: 1,
            title: "Virtual Survey",
            status: "completed"
        },
        {
            id: 2,
            title: "Report Created",
            status: "pending"
        }
    ]);

    // Update milestone status when hasReport changes
    useEffect(() => {
        if (hasReport !== undefined) {
            setMilestones(prevMilestones =>
                prevMilestones.map(milestone => {
                    if (milestone.id === 2) { // Report Created milestone
                        return {
                            ...milestone,
                            status: hasReport ? 'completed' : 'pending'
                        };
                    }
                    return milestone;
                })
            );
        }
    }, [hasReport]);

    const handleMilestoneClick = (milestoneId) => {
        // Only allow manual completion for pending milestones
        // and prevent changing status if it's controlled by hasReport prop
        if (milestoneId === 2 && hasReport !== undefined) {
            // Don't allow manual changes for "Report Created" when controlled by parent
            return;
        }

        setMilestones(prevMilestones =>
            prevMilestones.map(milestone => {
                if (milestone.id === milestoneId && milestone.status === 'pending') {
                    return {
                        ...milestone,
                        status: 'completed'
                    };
                }
                return milestone;
            })
        );
    };

    return (
        <div className="milestones-container">
            <div className="milestones-header">
                <h2 className="milestones-title">Milestones</h2>
            </div>

            <div className="milestones-list">
                {milestones.map((milestone) => (
                    <div
                        key={milestone.id}
                        className={`milestone-item ${milestone.status === 'completed'
                            ? 'milestone-completed'
                            : 'milestone-pending'
                            } ${milestone.id === 2 && hasReport !== undefined ? 'milestone-controlled' : ''}`}
                        onClick={() => handleMilestoneClick(milestone.id)}
                        style={{
                            cursor: milestone.id === 2 && hasReport !== undefined ? 'default' : 'pointer'
                        }}
                    >
                        <div className="milestone-icon">
                            {milestone.status === 'completed' ? (
                                <Check className="icon-check" />
                            ) : (
                                <Clock className="icon-clock" />
                            )}
                        </div>

                        <div className="milestone-content">
                            <span className={`milestone-text ${milestone.status === 'completed' ? 'text-completed' : 'text-pending'
                                }`}>
                                {milestone.title}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SurveyMilestones;